module.exports = __webpack_public_path__ + "img/CB12bs-Off-Off-1.f447a8be.gif";